import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import UserBaseForm from "./-form";
import { UserCrumbs } from "./-crumbs";
import { useCreateUser } from "@/requests/gen/react-query/user";
import { handleFormError } from "@/lib/handle-form-error";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/_admin/user/create")({
  component: UserCreatePage,
});

function UserCreatePage() {
  const createMutation = useCreateUser();
  const navigate = useNavigate();

  return (
    <div>
      <title>Create User - Legrande Health Portal</title>
      <UserCrumbs />

      <Card>
        <CardHeader>
          <CardTitle>New User</CardTitle>
          <CardDescription>Enter user details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <UserBaseForm
            onSubmit={(data, form) => {
              createMutation.mutate(
                { data },
                {
                  onSuccess: (response) => {
                    navigate({
                      to: "/user/$userId/entities",
                      params: { userId: String(response.user_id) },
                    });
                  },

                  onError: (error) => {
                    handleFormError({ error, form });
                  },
                },
              );
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
